module.exports = __webpack_public_path__ + "static/media/help_map_important.6c7c0893.svg";